// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"23":"86c8563b","141":"bf80a3c3","351":"a5a608c6","384":"0f5ea90f","539":"7e5457d3","812":"7e5457d3","942":"7e5457d3","961":"7e5457d3"}[chunkId] + ".chunk.css";
};